const parts = ['icon'];
const baseStyle = {
    icon: {},
};
export default {
    parts,
    baseStyle,
};
